import React, { useEffect, useState } from "react";

// 수학 계정 첫 화면에 한 번 띄우는 '유사유형 자동출제' 알림(2026-11-05 대표: 팝업으로 링크 누르면 사용법 보게).
//
// 제목 · 그림 한 장 · 버튼만 둔다(설명 줄은 사용법 페이지에). '사용법 보기' 는 /guide/math.html#similar 를 새 탭으로 연다.
// 본 것은 이 기기에만 남긴다(localStorage). 날짜가 지나면 아무에게도 안 뜬다.
// 리더스북 오픈 알림(ReadersBookLaunchPopup) 자리에 수학 계정만 이것을 띄운다. 차례는 onResolved 로 넘긴다.
const SEEN_KEY = "mathSimilarReviewLaunchSeen";
const LAST_SHOWN_DATE = "2026-11-30";
const GUIDE_URL = "/guide/math.html#similar";
const PREVIEW_SRC = "/guide/math/review_step.png";

const isSeen = () => {
  try {
    return window.localStorage.getItem(SEEN_KEY) === "1";
  } catch {
    return false;
  }
};

const MathSimilarReviewLaunchPopup = ({ onResolved }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const today = new Date().toLocaleDateString("sv-SE", { timeZone: "Asia/Seoul" });
    if (today <= LAST_SHOWN_DATE && !isSeen()) {
      setIsOpen(true);
    } else if (onResolved) {
      onResolved();
    }
  }, [onResolved]);

  if (!isOpen) return null;

  const close = () => {
    try {
      window.localStorage.setItem(SEEN_KEY, "1");
    } catch {
      // 저장이 막힌 브라우저는 다음에 한 번 더 뜬다
    }
    setIsOpen(false);
    if (onResolved) onResolved();
  };

  const buttonStyle = {
    flex: 1,
    border: "none",
    cursor: "pointer",
    fontWeight: 800,
    fontSize: "15px",
    padding: "13px 0",
    textAlign: "center",
    textDecoration: "none",
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(14,20,27,.55)",
        zIndex: 900,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "18px",
      }}
      onClick={close}
    >
      <div
        role="dialog"
        aria-label="유사유형 자동출제"
        onClick={(event) => event.stopPropagation()}
        style={{
          background: "#fff",
          maxWidth: "520px",
          width: "100%",
          maxHeight: "calc(100vh - 36px)",
          overflowY: "auto",
          boxShadow: "0 30px 70px -30px rgba(10,30,35,.6)",
        }}
      >
        <div style={{ background: "#0E141B", color: "#fff", padding: "20px 22px 18px", position: "relative" }}>
          <button
            type="button"
            aria-label="닫기"
            onClick={close}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              background: "none",
              border: "none",
              color: "#6d7d7b",
              fontSize: "18px",
              lineHeight: 1,
              cursor: "pointer",
              padding: "4px 6px",
            }}
          >
            ×
          </button>
          <div style={{ fontSize: "11px", fontWeight: 800, letterSpacing: ".1em", color: "#00D9C0", marginBottom: "8px" }}>
            NEW
          </div>
          <div style={{ fontSize: "20px", fontWeight: 800, lineHeight: 1.4 }}>유사유형 자동출제</div>
        </div>
        <div style={{ padding: "18px 22px 22px" }}>
          <a href={GUIDE_URL} target="_blank" rel="noopener noreferrer" onClick={close}>
            <img
              src={PREVIEW_SRC}
              alt="출제 창의 복습 설정"
              style={{ display: "block", width: "100%", height: "auto", border: "1px solid #E3E8EA" }}
            />
          </a>
          <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
            <button type="button" onClick={close} style={{ ...buttonStyle, background: "#F1F3F5", color: "#3A434E" }}>
              닫기
            </button>
            <a
              href={GUIDE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={close}
              style={{ ...buttonStyle, background: "#00A396", color: "#fff" }}
            >
              사용법 보기
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MathSimilarReviewLaunchPopup;
